module.exports = __webpack_public_path__ + "img/profile.23aa8805.png";